<template>
  <div>
    <form>
      <div class="m3phkn-form" id="form">
        <h3 class="m3phkn-form__heading">
          <span class="m3phkn--hakenbox">派遣求人</span>
          <span class="sp-block">お問い合わせはこちら</span>
        </h3>
        <step-map />
        <div class="m3phkn-inputarea">
          <router-view
            v-slot="{ Component }"
            @transit="name => setTransitionName(name)"
            @is-valid="result => (nextLinkEnabled = result)"
            :next-link-clicked="nextLinkClicked"
            :eopContents="eop_contents"
          >
            <transition
              @before-leave="handleBeforeLeaveTransition"
              :name="transitionName"
              mode="out-in"
            >
              <keep-alive>
                <component :is="Component" />
              </keep-alive>
            </transition>
          </router-view>

          <div class="contact-btn" v-if="route.meta.order < 3">
            <prev-link />
            <next-link :enabled="nextLinkEnabled" @click="handleClick" />
          </div>
          <div v-if="route.meta.order === 3">
            <div class="contact-text">
              <ul class="contact-privacy">
                <li>
                  <a
                    href="https://pcareer.m3.com/help/content#06"
                    title="利用規約"
                    @click.prevent="() => toggleModal(`terms-of-service`)"
                    rel="nofollow"
                    >利用規約について<i class="atlas-glyphs-m-arrow-right"></i
                  ></a>
                </li>
                <li>
                  <a
                    href="https://www.m3career.com/privacy/"
                    title="個人情報保護方針"
                    target="_blank"
                    rel="nofollow"
                    >個人情報保護方針について<i
                      class="atlas-glyphs-m-arrow-right"
                    ></i
                  ></a>
                </li>
              </ul>
            </div>
            <div class="contact-btn">
              <prev-link />
              <submit-button @click="handleSubmit" :enabled="nextLinkEnabled" />
            </div>
          </div>
        </div>
      </div>
    </form>
    <terms-modal :name="modalName" @close="() => toggleModal('')" />
    <loading-screen :opened="isProcessing" />
  </div>
</template>

<script setup>
import StepMap from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/components/others/StepMap';
import NextLink from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/components/others/NextLink';
import PrevLink from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/components/others/PrevLink';
import SubmitButton from '@component_path/pages/m3c_premium_inquiries/series/haken_tap_form/components/others/SubmitButton';
import TermsModal from '@component_path/slide_form_common_module/components/others/terms_modal';
import LoadingScreen from '@component_path/slide_form_common_module/components/others/loading_screen';
import { ref, computed, watch, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useForm } from 'vee-validate';
import { useRoute } from 'vue-router';

const store = useStore();
const route = useRoute();
const { validate } = useForm();

const props = defineProps({
  request_params: {
    type: Object,
    required: true
  },
  master_data: {
    type: Object,
    required: true
  },
  form_options: {
    type: Object,
    required: true
  },
  eop_contents: {
    type: Object,
    required: true
  }
});

const transitionName = ref('');
const modalName = ref('');
const nextLinkEnabled = ref(false);
const nextLinkClicked = ref(false);

const formData = computed(() => store.state.formData);
const isProcessing = computed(() => store.state.requestParam.is_processing);
const routePath = computed(() => route.path);

watch(routePath, () => {
  nextTick(() => {
    const element = document.querySelector('.m3phkn-inputarea');
    const targetPosition = element.offsetTop;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
    nextLinkClicked.value = false;
  });
});

const setTransitionName = transition => {
  transitionName.value = transition;
};

const handleClick = () => {
  nextLinkClicked.value = true;
};

const handleSubmit = () => {
  nextLinkClicked.value = true;
  if (nextLinkEnabled.value) {
    store.dispatch('submitForm');
  }
};

const toggleModal = name => {
  if (name === 'terms-of-service') {
    modalName.value = name;
  } else {
    modalName.value = '';
  }
};

const handleBeforeLeaveTransition = () => {
  nextLinkEnabled.value = false;
};

store.dispatch('prepareFormData', {
  preset_data: props.form_options,
  master_data: props.master_data,
  request_params: props.request_params
});
</script>

<style>
.next-slide-enter-active,
.next-slide-leave-active,
.back-slide-enter-active,
.back-slide-leave-active {
  transition: opacity 0.3s ease;
}
.next-slide-enter,
.next-slide-leave-active,
.back-slide-enter,
.back-slide-leave-active {
  transition: all 0.3s;
  opacity: 0;
}

.next-slide-leave-active {
  transform: translateX(-70px);
}

.back-slide-leave-active {
  transform: translateX(70px);
}

a:hover {
  cursor: pointer;
}
</style>
